import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map, tap } from "rxjs/operators";
import { QueryParamsModel } from "src/app/core/_base/crud";
import { SubdomainService } from "src/app/core/_base/subdomain.service";
import { MadAuthService } from "src/app/core/mad-auth/mad-auth.service";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: 'root'
})
export class LandmarksService {
  constructor(
    private http: HttpClient,
    private authService: MadAuthService,
    private subdomainService: SubdomainService
  ) { }

  getMapData(queryParams: QueryParamsModel) {
    const httpHeaders = this.authService.getAuthHeaders();
    let params = new HttpParams()
      .set('sortOrder', queryParams.sortOrder)
      .set('sortField', queryParams.sortField)

    if (queryParams.filter) {
      Object.keys(queryParams.filter).forEach(key => {
        const val = queryParams.filter[key];
        if (typeof val == 'number') {
          params = params.set(`filter[${key}]`, val.toString());
        }
        if (typeof val == 'string' && val != '') {
          params = params.set(`filter[${key}]`, val);
        } else if (key == 'key_categories') {
          params = params.set(`filter[${key}]`, val)
        }
        if (key == 'bounds' && val != null) {
          params = params.set(`filter[bounds][sw_lat]`, val.sw_lat);
          params = params.set(`filter[bounds][sw_lng]`, val.sw_lng);
          params = params.set(`filter[bounds][ne_lng]`, val.ne_lng);
          params = params.set(`filter[bounds][ne_lat]`, val.ne_lat);
        }
      })
    };

    return this.http.get<{data: unknown[]}>(
      `${environment.baseApiUrl}api/v2/${this.subdomainService.subDomain}/landmarks/list-map`,
      {
        headers: httpHeaders,
        params
      }
    ).pipe(
      map(response => response.data)
    )
  }
}